import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1605b0fe&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=1605b0fe&prod&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=1605b0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605b0fe",
  null
  
)

export default component.exports